/* eslint-disable */
export default {
  loading: '正在載入...',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
